<template>
    <div class="device-type-manange relative">
        <div class="buttons">
            <el-button @click="goSort">保存排序</el-button>
            <el-button :id="'systemUserAdd'" @click="goAdd">新增</el-button>
        </div>
        <!-- 表单开始 -->


        <!-- 表单结束 -->
        <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id"
            border :default-expand-all="false"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column prop="module_name" label="功能名称" align="left" label-class-name="label">

            </el-table-column>
            <el-table-column prop="path" label="跳转链接" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="showflag_text" label="是否隐藏" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="id" label="模块ID" align="center" label-class-name="label"></el-table-column>
            <el-table-column label="排序序号" align="center" label-class-name="label">
                <template scope="scope">
                    <el-input v-model="scope.row.sort" min="0"></el-input>
                </template>
            </el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'systemUserEdit'" @click="goAdd(scope.row)" type="text" v-if="scope.row.pid == 1">
                    添加子菜单
                </el-button>
                <el-button :id="'systemUserEdit'" @click="goEdit(scope.row)" type="text">
                    编辑
                </el-button>
<!--                <el-button :id="'systemUserDel'" @click="del_menu(scope.row)" type="text">-->
<!--                    删除-->
<!--                </el-button>-->
            </el-table-column>
        </el-table>

    </div>
</template>
<script>
    import {check} from "@/utils/checkData";
    import {getUserInfos} from '@/utils/userInfos';

    export default {
        data() {
            return {
                search_data: null,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                //删除确认
                deleteDialogVisible: false,
                delete_id: '',
                is_submit: false,
            };
        },
        mounted() {
            // 获取菜单列表
            this.getList();
            localStorage.setItem('prev_page', 'menu_list')
        },
        methods: {
            // 获取所有设备类型
            getList() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'getMenu',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {

                      res.data.data.list[i].showflag_text = res.data.data.list[i].showflag == 1 ? '显示' : '隐藏'

                        if (res.data.data.list[i].children) {
                            for (var j = 0; j < res.data.data.list[i].children.length; j++) {
                                res.data.data.list[i].children[j].showflag_text = res.data.data.list[i].children[j].showflag == 1 ? '显示' : '隐藏'
                            }
                        }
                    }
                    this.tableData = res.data.data.list;
                });
            },
            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },
            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },
            // 排序
            goSort() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                let sortData = this.getSortData(this.tableData);

                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'reSort',
                    params: {
                        sortData: sortData
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '修改成功',
                        duration: 1500,
                    });
                    _that.getList();
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 跳转编辑页
            goEdit(data) {
                this.$router.push({
                    name: "menuEdit",
                    params: {
                        id: data.id,
                        pid: data.pid,
                        module_name: data.module_name,
                        name: data.name,
                        path: data.path,
                        meta: data.meta,
                        sort: data.sort,
                        showflag: data.showflag,
                        menu_parent: data.menu_parent,
                    }
                });
            },

            // 跳转添加页
            goAdd(data) {
                if (data.pid) {
                    this.$router.push({name: "menuAdd", params: {pid: data.id}});
                } else {
                    this.$router.push({name: "menuAdd"});
                }

            },

            // 删除账号
            del_menu(val) {
                var message = '确定该删除该菜单吗?';
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminSystemServices',
                        method: 'delMenu',
                        params: {
                            id: val.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message.success('删除成功！');
                        this.getList();
                    });
                }).catch(() => {
                });
            },
            getSortData(data) {
                let res = [];
                let child = [];
                for (let i = 0; i < data.length; i++) {
                    res.push({
                        id: data[i].id,
                        sort: data[i].sort,
                    })
                    if (data[i].children) {
                        child = this.getSortData(data[i].children)
                        res = res.concat(child)
                    }
                }
                return res;
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";
</style>
